import { CLOUDINARY_URLS } from '../Constants/Urls.constants';

// eslint-disable-next-line no-restricted-globals
export const withOrigin = () => location.origin;

export const concatenateWithOrigin = (path: string) => withOrigin().concat(path);

export const createCloudinaryUrl = (imageId: string, transforms = '') =>
  `${CLOUDINARY_URLS.CUSTOM}${transforms}/${imageId}`;

export const getCloudinaryTransformations = (url: string) => {
  const transforms = url.match(/(?:\/)([A-Za-z]_[a-z_,0-9]+)+/g);

  return transforms ? transforms.join('') : '';
};

export const addTransformationsToCloudinary = (
  url: string | undefined = '',
  transforms: string[],
) => {
  if (!url) {
    return url;
  }

  const existingTransforms = getCloudinaryTransformations(url);

  if (existingTransforms && existingTransforms.length > 0) {
    const replaceTransforms = `${existingTransforms},${transforms.join(',')}`;
    return url.replace(existingTransforms, replaceTransforms);
  }

  return url.replace('upload/', `upload/${transforms.join(',')}/`);
};

export const objectToFormData = (obj: Record<string, any>) => {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key]);
  });

  return formData;
};
